import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';

interface CalculatorResultProps {
  upperLabel?: string;
  lowerLabel?: string;
  value?: string;
}

const CalculatorResult = ({ upperLabel, lowerLabel, value }: CalculatorResultProps): JSX.Element => (
  <Stack
    padding={['spacing-3xl', 'spacing-4xl']}
    gap='spacing-md'
    background='bg-brand-secondary'
    direction='column'
  >
    {upperLabel && (
      <Typography
        type='paragraph'
        size='xl'
        textAlign='center'
      >
        {upperLabel}
      </Typography>
    )}

    {value && (
      <Typography
        type='heading'
        size='lg'
        textAlign='center'
      >
        {value}
      </Typography>
    )}

    {lowerLabel && (
      <Typography
        type='paragraph'
        size='xl'
        textAlign='center'
      >
        {lowerLabel}
      </Typography>
    )}
  </Stack>
);

export default CalculatorResult;
